export const APPROVAL_ODDS_BANNER_SECTION = 'approval_odds_banner';

export type ApprovalOddsErrorType =
  | 'identity_not_matched'
  | 'invalid_code'
  | 'expired_code'
  | 'debt_profile_error'
  | 'debt_profile_incomplete'
  | 'model_error';

// Cards legacy Page Action `action_name` values for the activation form.
export type ApprovalOddsStepActionName =
  | 'approval_odds_identity_viewed'
  | 'approval_odds_identity_submitted'
  | 'approval_odds_identity_error'
  | 'approval_odds_phone_verification_viewed'
  | 'approval_odds_phone_verification_submitted'
  | 'approval_odds_phone_verification_error'
  | 'approval_odds_retrieval_error';
